import Auth from "./auth/reducer";
import Athletes from "./athletes/reducer";
import Programming from "./programming/reducer";
import Exercises from "./exercises/reducer";
import Calendar from "./calendar/reducer";
import RightBar from "./rightbar/reducer";
import ActiveProgram from "./activeprogram/reducer";
import InfoItems from "./infoitems/reducer";

export default {
  Athletes,
  Auth,
  Calendar,
  Programming,
  Exercises,
  RightBar,
  ActiveProgram,
  InfoItems,
};
